"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function RemoveAllDialogView(props) {
  var open = props.open,
    toggleDisplay = props.toggleDisplay,
    count = props.count,
    removeAllFiles = props.removeAllFiles;
  var deleteAllFiles = function deleteAllFiles() {
    removeAllFiles();
    toggleDisplay();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: open,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.DialogContentText, {
    id: "alert-dialog-description"
  }, "Remove", ' ', /*#__PURE__*/_react.default.createElement("b", null, "All files", ' (', count, ') '), "From Cart")), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "okBtn",
    onClick: deleteAllFiles
  }, "Ok"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "cancelBtn",
    onClick: function onClick() {
      return toggleDisplay();
    }
  }, "Cancel"))));
}
var _default = RemoveAllDialogView;
exports.default = _default;